import { Controller } from "@hotwired/stimulus"

// コードブロックの「Copy」ボタン用コントローラー
// data-controller="clipboard" を持つラッパー要素に接続される
export default class extends Controller {
  static targets = ["label"]

  async copy() {
    const code = this.element.querySelector("code")
    if (!code) return

    const text = code.innerText

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      // Fallback: execCommand（古いブラウザ向け）
      const ta = document.createElement("textarea")
      ta.value = text
      Object.assign(ta.style, { position: "fixed", opacity: "0", top: "0", left: "0" })
      document.body.appendChild(ta)
      ta.select()
      document.execCommand("copy")
      document.body.removeChild(ta)
    }

    this.showFeedback()
  }

  showFeedback() {
    if (!this.hasLabelTarget) return

    const btn = this.labelTarget.closest("button")
    this.labelTarget.textContent = "Copied! ✅"
    btn?.classList.add("!text-green-400")

    setTimeout(() => {
      this.labelTarget.textContent = "Copy"
      btn?.classList.remove("!text-green-400")
    }, 2000)
  }
}
